import { UntypedFormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class TimePickerMatcher implements ErrorStateMatcher {
	isErrorState(control: UntypedFormControl | null): boolean {
		return (
			(control.hasError('invalidTimeRange') || control.invalid) &&
			control.touched
		);
	}
}
